interface ErrorNames {
    applicationInvalid: string;
    applicationNotFound: string;
    applicationStatusUnknown: string;
    applicationCaseNotFound: string;
    applicationRequestInvalid: string;
    applicationLoanAmountNotInRange: string;
    applicationLoanAgeLimit: string;
    applicationRegNoInvalid: string;
    customerIsAnonymous: string;
    customerIsDNumber: string;
    customerIsMinor: string;
    customerIsMissingBisnode: string;
    customerIsMissingAddress: string;
    customerNoAccess: string;
    customerContextMissing: string;
    customerMissingAccess: string;
    customerNotInBank: string;
    internalError: string;
    invalidSSN: string;
    priceError: string;
    productUnknown: string;
    serviceNotAvailable: string;
    vehicleRegNoMissing: string;
    vehicleRegNoNotFound: string;
    otherApplicantMissingData: string;
    sblSaveError: string;
    sblTaxYearError: string;
    incorrectNewCase: string;
    eurotaxPlateNotFound: string;
    upgradeToVehicleLoanFailed: string;
    kycBlocked: string;
    dsfDataNotFound: string;
}
export const errorNames: ErrorNames = {
    applicationInvalid: 'UGYLDIG_SOKNAD',
    applicationNotFound: 'APPLICATION_NOT_FOUND',
    applicationStatusUnknown: 'UNKNOWN_APPLICATION_STATUS',
    applicationCaseNotFound: 'PREVIEW_CASE_NOT_FOUND',
    applicationRequestInvalid: 'INVALID_APPLICATION_REQUEST',
    applicationLoanAmountNotInRange: 'LOAN_AMOUNT_NOT_IN_RANGE',
    applicationLoanAgeLimit: 'LOAN_AND_CARS_AGE_EXCEED_LIMIT',
    applicationRegNoInvalid: 'REGISTRATION_NR_INVALID',
    customerIsAnonymous: 'ANNONYM_BRUKER',
    customerIsDNumber: 'DNUMMER_KUNDE',
    customerIsMinor: 'MINDREAARIG_KUNDE',
    customerIsMissingBisnode: 'AAA_SOLIDITY',
    customerIsMissingAddress: 'NO_ADDRESS_FOUND',
    customerNoAccess: 'INGEN_TILGANG',
    customerContextMissing: 'MANGLER_USER_CTX',
    customerMissingAccess: 'MANGLER_TILGANG',
    customerNotInBank: 'FNR_BANKIDBRUKER_MISMATCH',
    internalError: 'INTERN_FEIL',
    invalidSSN: 'UGYLDIG_FOEDESELSNUMMER',
    priceError: 'FEIL_UNDER_PRISOPPSLAG',
    productUnknown: 'UNKNOWN_PRODUCT',
    serviceNotAvailable: 'SERVICE_UNAVAILABLE',
    vehicleRegNoMissing: 'REGNR_MANGLER',
    vehicleRegNoNotFound: 'EUROTAX_PLATE_NOT_FOUND',
    otherApplicantMissingData: 'OTHER_APPLICANT_MISSING_DATA',
    sblSaveError: 'FAILED_SBL_CONSENT_SAVE',
    sblTaxYearError: 'NO_TAX_PERIOD_AVAILABLE',
    incorrectNewCase: 'INCORRECT_NEW_CASE',
    eurotaxPlateNotFound: 'EUROTAX_PLATE_NOT_FOUND',
    upgradeToVehicleLoanFailed: 'UPGRADE_TO_VEHICLE_LOAN_FAILED',
    kycBlocked: 'KYC_BLOCKED',
    dsfDataNotFound: 'DSF_DATA_NOT_FOUND',
};

interface ServiceErrors {
    ErrorsToBeAddedHere: string;
}

export const serviceErrors: ServiceErrors = {
    ErrorsToBeAddedHere: 'ErrorsToBeAddedHere',
    /* */
};

export const serviceError = 'service_error';
export const genericError = 'generic_error';

export const getErrorMessage = (errorName: string) => {
    let errorMessage = genericError;

    const serviceKeys: (keyof ServiceErrors)[] = Object.keys(serviceErrors) as (keyof ServiceErrors)[];
    serviceKeys.forEach((key: keyof ServiceErrors) => {
        if (serviceErrors[key] === errorName) errorMessage = serviceError;
    });

    const keys: (keyof ErrorNames)[] = Object.keys(errorNames) as (keyof ErrorNames)[];
    keys.forEach((key: keyof ErrorNames) => {
        if (errorNames[key] === errorName) errorMessage = errorName;
    });
    return errorMessage;
};
